import { FormBase } from "../../util/form-base-form";

export class AdsAdminForm extends FormBase {
    public root: HTMLElement;

    public constructor(root: HTMLElement) {
        super();
        this.root = root;
    }

    public static getRoots(root: ParentNode): HTMLElement[] {
        return new AdsAdminForm(document.body).queryElements(root, ".ads-admin", HTMLElement);
    }

    public getRoot(): HTMLElement {
        return this.root;
    }

    public isInitialized(): boolean {
        return this.root.dataset.adsAdminInit === "1";
    }

    public markInitialized(): void {
        this.root.dataset.adsAdminInit = "1";
    }

    public getListEl(): HTMLElement | null {
        return this.queryElement(this.root, ".js-ad-admin-list", HTMLElement);
    }

    public getEditButton(root: EventTarget | Element | null | undefined): HTMLButtonElement | null {
        return this.closest(root, ".js-ad-admin-edit-toggle", HTMLButtonElement);
    }

    public getDeleteButton(root: EventTarget | Element | null | undefined): HTMLButtonElement | null {
        return this.closest(root, ".js-ad-admin-delete", HTMLButtonElement);
    }

    public getBannerTrigger(root: EventTarget | Element | null | undefined): HTMLButtonElement | null {
        return this.closest(root, ".js-ad-banner-trigger", HTMLButtonElement);
    }

    public getBannerInput(root: EventTarget | Element | null | undefined): HTMLInputElement | null {
        return this.closest(root, ".js-ad-banner-input", HTMLInputElement);
    }

    public getRow(root: EventTarget | Element | null | undefined): HTMLFormElement | null {
        return this.closest(root, ".users-admin__row", HTMLFormElement);
    }

    public getSubmitButton(root: ParentNode): HTMLButtonElement | null {
        return this.queryElement(root, 'button[type="submit"]', HTMLButtonElement);
    }

    public getField(root: ParentNode, name: string): HTMLElement | null {
        return this.queryElement(root, `[name="${name}"]`, HTMLElement);
    }

    public getFieldDisplay(root: ParentNode, field: string): HTMLElement | null {
        return this.queryElement(root, `[data-field="${field}"]`, HTMLElement);
    }

    public getBannerInputForRow(row: ParentNode): HTMLInputElement | null {
        return this.queryElement(row, ".js-ad-banner-input", HTMLInputElement);
    }

    public getBannerPreviewImg(row: ParentNode): HTMLImageElement | null {
        return this.queryElement(row, ".js-ad-banner-preview-img", HTMLImageElement);
    }

    public getBannerStatus(row: ParentNode): HTMLElement | null {
        return this.queryElement(row, ".js-ad-banner-status", HTMLElement);
    }

    public getBannerTriggerForRow(row: ParentNode): HTMLButtonElement | null {
        return this.queryElement(row, ".js-ad-banner-trigger", HTMLButtonElement);
    }

    public getAddOpenButton(): HTMLButtonElement | null {
        return this.queryElement(document.body, ".js-ad-admin-add-open", HTMLButtonElement);
    }

    public getCreateModal(): HTMLElement | null {
        return this.queryElement(document.body, ".js-ad-admin-create-modal", HTMLElement);
    }

    public getCreateForm(): HTMLFormElement | null {
        return this.queryElement(document.body, ".js-ad-admin-create-form", HTMLFormElement);
    }

    public getCreateCloseButtons(): HTMLElement[] {
        return this.queryElements(document.body, ".js-ad-admin-create-close", HTMLElement);
    }

    public getCreateAdTypeSelect(): HTMLSelectElement | null {
        return this.queryElement(document.body, ".js-ad-admin-create-ad-type", HTMLSelectElement);
    }

    public getCreateAdTitleInput(): HTMLInputElement | null {
        return this.queryElement(document.body, ".js-ad-admin-create-ad-title", HTMLInputElement);
    }

    public getCreateAdBodyInput(): HTMLTextAreaElement | null {
        return this.queryElement(document.body, ".js-ad-admin-create-ad-body", HTMLTextAreaElement);
    }

    public getCreateLinkUrlInput(): HTMLInputElement | null {
        return this.queryElement(document.body, ".js-ad-admin-create-link-url", HTMLInputElement);
    }

    public getCreateProductIdInput(): HTMLInputElement | null {
        return this.queryElement(document.body, ".js-ad-admin-create-product-id", HTMLInputElement);
    }

    public getCreateDisplayRateInput(): HTMLInputElement | null {
        return this.queryElement(document.body, ".js-ad-admin-create-display-rate", HTMLInputElement);
    }

    public getCreateBannerInput(): HTMLInputElement | null {
        return this.queryElement(document.body, ".js-ad-admin-create-banner", HTMLInputElement);
    }

    public getCreateSubmitButton(): HTMLButtonElement | null {
        return this.queryElement(document.body, ".js-ad-admin-create-submit", HTMLButtonElement);
    }
}
